import React, { useEffect, useState } from 'react'
import { Box, Button, Stack, TextField, Typography } from '@mui/material'
import { exerciseOptions, fetchData } from '../utils/FetchData'
import HorizontalScrollbar from './HorizontalScrollbar';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function SearchExercies({ setExercises, bodyPart, setBodyPart }) {
    const [Search, setSearch] = useState('');
    const [bodyParts, setBodyParts] = useState([])

    useEffect(() => {
        const fetchExercisesData = async () => {
            const bodyPartsData = await fetchData('https://exercisedb.p.rapidapi.com/exercises/bodyPartList', exerciseOptions);
            setBodyParts(['all', ...bodyPartsData])

        }
        fetchExercisesData()
    }, [])
    const handleSearch = async () => {

        const exercisesData1 = await fetchData('https://exercisedb.p.rapidapi.com/exercises', exerciseOptions);
        const exercisesData2 = await fetchData(`https://exercisedb.p.rapidapi.com/exercises/name/${Search}`, exerciseOptions)
        // const exercisesData3= await fetchData(`https://exercisedb.p.rapidapi.com/exercises/target/${Search}`,exerciseOptions)
        let finalData = [...exercisesData1, ...exercisesData2,];

        if (Search) {
            const finalSearchedData = finalData.filter(
                (item) => item.name.toLowerCase().includes(Search)
                    || item.target.toLowerCase().includes(Search)
                    || item.equipment.toLowerCase().includes(Search)
                    || item.bodyPart.toLowerCase().includes(Search),
            );


            window.scrollTo({ top: 1800, left: 100, behavior: 'smooth' });


            setSearch('');
            setExercises(finalSearchedData);
            // console.log(exercises)
        }
    }
    const showToastMessage = () => {
        toast.success('Searching ...', {
            position: toast.POSITION.TOP_RIGHT
        });
    };
    const showToastMessage1 = () => {
        toast('Click On Exercie To Know Steps', {
            position: toast.POSITION.BOTTOM_LEFT
        });
    };
    return (


        <Stack alignItems='center' mt='37px' justifyContent='center' p='20px'>
            <Typography fontWeight={700} sx={{
                fontSize: { lg: '44px', xs: '30px' }
            }} textAlign='center' mb='50px'>
                Awesome Exercises You <br /> Should Know
            </Typography>
            <Box position='relative' mb='72px'>
                <TextField height="76px"
                    value={Search}
                    sx={{
                        input: {
                            fontWeight: 700, border: 'none', borderRadius: '4px'
                        },
                        width: { lg: '800px', xs: '350px' },
                        backgroundColor: '#fffff',
                        borderRadius: '40px'

                    }}
                    onChange={(e) => setSearch(e.target.value.toLowerCase())} placeholder='Search Exercises' type='text' />
                <Button className='search-btn'
                    sx={{
                        bgcolor: '#ff2625',
                        color: '#fff',
                        textTransform: 'none',
                        width: {
                            lg: '185px', xs: '100px',
                            fontSize: { lg: '20px', xs: '14px' },
                            height: '56px',
                            position: 'absolute',
                            right: '0'
                        }
                    }}
                    onClick={
                        () => {
                            handleSearch()
                            showToastMessage()
                            showToastMessage1()
                        }
                    }
                >Search</Button>
            </Box>
            <Box sx={{ position: 'relative', width: '100%', p: '20px' }}>
                <HorizontalScrollbar data={bodyParts} setBodyPart={setBodyPart} bodyPart={bodyPart} />
            </Box>
            <ToastContainer />
        </Stack>

    )
}

export default SearchExercies